export { BadgeColor } from './src/badge.component';
export * from './src/badge.module';
